import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const transactionService = {
    getAllTransactions,
    getTransaction   
};

const MODULE = {
    TRANSACTION: 'transactions',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllTransactions(filter) {

    const requestOptions = {
        params: {
            page: filter.pageNumber,
            size: filter.pageSize,
            is_locked: filter.isLocked,
            is_active: filter.isActive
        }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`
            requestOptions.params[searchParam] = word
        }
    })

    return apiHelper(API_URL).get(`/${MODULE.TRANSACTION}`, requestOptions)
}


export function getTransaction(id) {
    return apiHelper(API_URL).get(`/${MODULE.TRANSACTION}/${id}`)
}